var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTotalShelterProvied(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 93,
    height: 93,
    viewBox: "0 0 93 93",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Total_Shelter",
    "data-name": "Total Shelter",
    transform: "translate(-455 -169)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4265",
    "data-name": "Rectangle 4265",
    width: 93,
    height: 93,
    rx: 10,
    transform: "translate(455 169)",
    fill: "#eaf8ff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "exchange",
    transform: "translate(480.75 193.32)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9842",
    "data-name": "Path 9842",
    d: "M38.575,8.833,32.443,2.7a1.534,1.534,0,0,0-2.169,2.169L33.79,8.386H8.873a5.626,5.626,0,0,0-5.622,5.622v6.131a1.533,1.533,0,0,0,3.066,0V14.007a2.559,2.559,0,0,1,2.555-2.555H33.79l-3.516,3.516a1.533,1.533,0,1,0,2.167,2.169L38.573,11a1.534,1.534,0,0,0,0-2.169Z",
    transform: "translate(0.001)",
    fill: "#35b0eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9843",
    "data-name": "Path 9843",
    d: "M35.447,12.251a1.534,1.534,0,0,0-1.533,1.533v6.131a2.559,2.559,0,0,1-2.555,2.555H8.485L12,18.954a1.534,1.534,0,0,0-2.169-2.169L3.7,22.918a1.534,1.534,0,0,0,0,2.169L9.832,31.22A1.533,1.533,0,0,0,12,29.051L8.483,25.535H31.356a5.626,5.626,0,0,0,5.622-5.622V13.782a1.534,1.534,0,0,0-1.533-1.533Z",
    transform: "translate(0 10.44)",
    fill: "#35b0eb"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalShelterProvied);
export default __webpack_public_path__ + "static/media/Total-Shelter-provied.3efe3f87b93310566a00249fe40317bf.svg";
export { ForwardRef as ReactComponent };